export default __webpack_public_path__ + "335be137685529867ae06aba47230481.woff";